import { Td } from './styles'
import { formatDate } from '../../../utils/formatDate'
import { Box, Flex, Icon, Text, Tooltip } from '@chakra-ui/react'
import { Tr } from '@chakra-ui/table'
import React from 'react'
import { ModalFaltante } from './components/ModalFaltante'
import { user } from '../../../helpers/user'
import { format } from 'date-fns'
import { FaStar } from 'react-icons/fa'

export function Row({ item, index, newDateItens, visibleForThisUserCode, isVendedor }) {
  function firstLetterUpper(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  const itemFaltante = newDateItens.filter((i) => i.PEDIDO === item.PEDIDO && i.contador_pedidos !== i.contador_tela)

  const shipping = {
    TRANSPORTADORA: 'TR',
    MotoBoy: 'MB',
    'CLIENTE RETIRA AS 17H': 'CR 17H',
    'NOSSO CARRO 8H30': 'NC 8H30',
    'NOSSO CARRO 17': 'NC 8H30',
  }

  return (
    <Tr key={index}>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Flex flexDir="column">
          {item.cliente_importante && <Icon as={FaStar} color="#FFD700" w={5} h={5} alignSelf="center" />}
          <Text>{item.DATA_CLIENTE && format(new Date(item.DATA_CLIENTE), 'dd/MM/yyyy')}</Text>
          <Text>{item.DATA_CLIENTE && format(new Date(item.DATA_CLIENTE), 'HH:mm')}</Text>
        </Flex>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Text
          as={'a'}
          color={item.LINK_LAYOUT === '' ? 'red.500' : 'blue.500'}
          href={item.LINK_LAYOUT}
          _hover={{ textDecoration: 'underline', filter: 'brightness(0.8)' }}
          target="_blank"
          rel="noreferrer"
        >
          {firstLetterUpper(item.PEDIDO)}
        </Text>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Tooltip label={item.nome_empresa || 'N/A'} hasArrow>
          <Text isTruncated maxWidth="100px">
            {item.nome_empresa || 'N/A'}
          </Text>
        </Tooltip>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        {firstLetterUpper(item.CODIGO)}
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <ModalFaltante item={item} itemFaltante={itemFaltante} />
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Box maxW="100px" whiteSpace="normal">
          <Tooltip label={item?.DESCRICAO} hasArrow>
            <Text textTransform="capitalize">{item.DESCRICAO?.toLowerCase()}</Text>
          </Tooltip>
        </Box>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Box maxW="66px" whiteSpace="normal" textTransform="capitalize">
          {item.COR?.toLowerCase()}
        </Box>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        {item.batidas && item.batidas > 1 ? item.QUANTIDADE + ' x ' + item.batidas : item.QUANTIDADE}
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Box maxW="100px" whiteSpace="normal">
          <Tooltip label={item?.GRAVACAO} hasArrow>
            {firstLetterUpper(item.GRAVACAO)}
          </Tooltip>
        </Box>
      </Td>

      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        {item.DATA_COMPRA ? (
          <Flex flexDir="column">
            <Text>{format(new Date(item.DATA_COMPRA), 'dd/MM/yyyy')}</Text>
            {/* mostra apenas as horas e minutos da datacompra */}
            <Text as="span">{format(new Date(item.DATA_COMPRA), 'HH:mm')}</Text>
          </Flex>
        ) : (
          'Sem data'
        )}
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        {/* {item.DATA_RECEBIMENTO.substring(0, 10).split('-').reverse().join('/')} */}
        {item.DATA_RECEBIMENTO ? (
          <Flex flexDir="column">
            <Text>{format(new Date(item.DATA_RECEBIMENTO), 'dd/MM/yyyy')}</Text>
            <Text>{format(new Date(item.DATA_RECEBIMENTO), 'HH:mm')}</Text>
          </Flex>
        ) : (
          item.DATA_RECEBIMENTO
        )}
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Flex flexDir="column" alignItems="center" gap={1} maxW="100px" whiteSpace="normal">
          <Text as="span" textTransform="capitalize">
            {item.PASSO_ATUAL?.toLowerCase()}{' '}
          </Text>
          <Text as="span">{item.data_passo_atual}</Text>
        </Flex>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        <Box maxW="130px" whiteSpace="normal" textTransform="capitalize">
          {item.PROXIMO_PASSO?.toLowerCase()}
        </Box>
      </Td>
      <Td
        {...(item.cliente_importante && {
          borderBottom: '2px solid',
          borderTop: '2px solid',
          borderColor: '#FFD700!important',
        })}
      >
        {firstLetterUpper(item.PRAZO) + ' dias'}
      </Td>
      {visibleForThisUserCode.includes(user?.codigo_usuario) && !isVendedor && (
        <Td
          {...(item.cliente_importante && {
            borderBottom: '2px solid',
            borderTop: '2px solid',
            borderColor: '#FFD700!important',
          })}
        >
          {item.PREVISAO_SAIDA ? format(new Date(item?.PREVISAO_SAIDA), 'dd/MM/yyyy') : 'Sem data'}
        </Td>
      )}

      {isVendedor && (
        <Td
          {...(item.cliente_importante && {
            borderBottom: '2px solid',
            borderTop: '2px solid',
            borderColor: '#FFD700!important',
          })}
        >
          {item.data_saida}
        </Td>
      )}

      {/*<Td>{item.usuario_emissao_nota ? item.usuario_emissao_nota : "Não informado"}</Td>*/}
      {/*<Td>{item.usuario_geracao_etiqueta ? item.usuario_geracao_etiqueta : "Não informado"}</Td>*/}
      {visibleForThisUserCode.includes(user?.codigo_usuario) && (
        <Td
          {...(item.cliente_importante && {
            borderBottom: '2px solid',
            borderTop: '2px solid',
            borderColor: '#FFD700!important',
          })}
        >
          <Tooltip label={item?.ENTREGA} hasArrow>
            {shipping[item.ENTREGA]}
          </Tooltip>
        </Td>
      )}
    </Tr>
  )
}
